import type { FaqItem } from "@/types/content";
import "./Faq.css";

export function Faq({ items }: { items: FaqItem[] }) {
  return (
    <dl className="faq">
      {items.map((item) => (
        <div className="faq-item" key={item.question}>
          <dt>
            <details>
              <summary>{item.question}</summary>
              <p>{item.answer}</p>
            </details>
          </dt>
        </div>
      ))}
    </dl>
  );
}
